import { blobticService } from '../../Commun/services/blobticService';
import { MaterialType } from './windowsApi';

export enum DoorTypeEnum {
    Single = 1,
    Double = 2,
    Sliding = 3,
    Folding = 4,
    Revolving = 5,
}

export interface DoorDto {
    DOR_IDF: number;
    PRJ_IDF: number;
    DOR_TYPE: number;
    DOR_SHAPE: number;
    DOR_WIDTH: number;
    DOR_HEIGHT: number;
    DOR_MATERIAL_TYPE: number;
    PRF_IDF?: number;
    DOR_DATA?: string;
    LAST_UPDT?: string;
}

export interface Door {
    id: number;
    projectId: number;
    doorType: DoorTypeEnum;
    shapeType: number;
    width: number;
    height: number;
    materialType: MaterialType;
    profileId?: number;
    customShapeData?: string;
    createdDate: string;
    modifiedDate?: string;
}

const mapDtoToModel = (dto: DoorDto): Door => ({
    id: dto.DOR_IDF,
    projectId: dto.PRJ_IDF,
    doorType: dto.DOR_TYPE,
    shapeType: dto.DOR_SHAPE,
    width: dto.DOR_WIDTH,
    height: dto.DOR_HEIGHT,
    materialType: dto.DOR_MATERIAL_TYPE,
    profileId: dto.PRF_IDF,
    customShapeData: dto.DOR_DATA,
    createdDate: dto.LAST_UPDT || new Date().toISOString(),
    modifiedDate: dto.LAST_UPDT
});

const mapModelToDto = (model: Partial<Door>): Partial<DoorDto> => ({
    DOR_IDF: model.id,
    PRJ_IDF: model.projectId,
    DOR_TYPE: model.doorType,
    DOR_SHAPE: model.shapeType,
    DOR_WIDTH: model.width,
    DOR_HEIGHT: model.height,
    DOR_MATERIAL_TYPE: model.materialType,
    PRF_IDF: model.profileId,
    DOR_DATA: model.customShapeData
});

export const doorsApi = {
    getAll: async () => {
        const response = await blobticService.executeZoomRequest<DoorDto[]>({
            ZoomKey: 'Blobtic_Maker',
            Action: { OKey: 'Blobtic_Maker,maker_door,Select' }
        });
        return { data: (response.data || []).map(mapDtoToModel) };
    },

    getByProject: async (projectId: number) => {
        const response = await blobticService.executeZoomRequest<DoorDto[]>({
            ZoomKey: 'Blobtic_Maker',
            Action: {
                OKey: 'Blobtic_Maker,maker_door,Select',
                PRJ_IDF: projectId
            }
        });
        return { data: (response.data || []).map(mapDtoToModel) };
    },

    getById: async (id: number) => {
        const response = await blobticService.executeZoomRequest<DoorDto[]>({
            ZoomKey: 'Blobtic_Maker',
            Action: {
                OKey: 'Blobtic_Maker,maker_door,Select',
                DOR_IDF: id
            }
        });
        const dto = response.data?.[0];
        return {
            data: dto ? mapDtoToModel(dto) : null,
            message: response.message
        };
    },

    create: async (door: Partial<Door>) => {
        const dto = mapModelToDto(door);
        const response = await blobticService.executeZoomRequest<DoorDto[]>({
            ZoomKey: 'Blobtic_Maker',
            Action: {
                OKey: 'Blobtic_Maker,maker_door,Insert',
                ...dto
            }
        });
        return {
            data: response.data?.[0] ? mapDtoToModel(response.data[0]) : null,
            message: response.message
        };
    },

    update: async (id: number, door: Partial<Door>) => {
        const dto = mapModelToDto(door);
        const response = await blobticService.executeZoomRequest<DoorDto[]>({
            ZoomKey: 'Blobtic_Maker',
            Action: {
                OKey: 'Blobtic_Maker,maker_door,Update',
                DOR_IDF: id,
                ...dto
            }
        });
        return {
            data: response.data?.[0] ? mapDtoToModel(response.data[0]) : null,
            message: response.message
        };
    },

    delete: async (id: number) => {
        const response = await blobticService.executeZoomRequest({
            ZoomKey: 'Blobtic_Maker',
            Action: {
                OKey: 'Blobtic_Maker,maker_door,Delete',
                DOR_IDF: id
            }
        });
        return {
            success: true,
            message: response.message
        };
    }
};
